import { render, staticRenderFns } from "./get-started.vue?vue&type=template&id=4fc4e23f&scoped=true"
import script from "./get-started.vue?vue&type=script&lang=js"
export * from "./get-started.vue?vue&type=script&lang=js"
import style0 from "./get-started.vue?vue&type=style&index=0&id=4fc4e23f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc4e23f",
  null
  
)

export default component.exports